import { api } from "api/base";

export const getDeliveries = async () => {
    const response = await api.get('/deliveries');
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};

export const createDeliveryGroup = async (orderIds: string[], routeId: string) => {
    const response = await api.post('/deliveries', { order_ids:orderIds, route_id: routeId });
    if (response.status === 200) {
        response.data.created_at = convertToLocalTime(response.data.created_at)
        response.data.updated_at = convertToLocalTime(response.data.updated_at)
        return response.data;
    } else {
        return null;
    }
};


export const completeDelivery = async (deliveryId: string, comment: string) => {
    const response = await api.post(`/deliveries/${deliveryId}/complete`, { comment });
    if (response.status === 200) {
        response.data.created_at = convertToLocalTime(response.data.created_at)
        response.data.updated_at = convertToLocalTime(response.data.updated_at)
        return response.data;
    } else {
        return null;
    }
};

export const completeDeliveryGroup = async (deliveryGroupId: string) => {
    const response = await api.post(`/deliveries/group/${deliveryGroupId}/complete`);
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};

export const reopenDelivery = async (deliveryId: string) => {
    const response = await api.post(`/deliveries/${deliveryId}/reopen`);
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};


const convertToLocalTime = (dateString: string) => {
    const date = new Date(dateString);
    const timeZoneOffset = new Date().getTimezoneOffset();
    const localDate = new Date(date.getTime() - timeZoneOffset * 60000);
    return localDate.toISOString();
}

export const reportDeliveryProblem = async (deliveryId: string, status: string, comment: string, comment_code_id: string) => {
    const response = await api.post(`/deliveries/${deliveryId}/report-problem`, {  status, comment, comment_code_id });
    if (response.status === 200) {
        response.data.created_at = convertToLocalTime(response.data.created_at)
        response.data.updated_at = convertToLocalTime(response.data.updated_at)
        return response.data;
    } else {
        return null;
    }
};


export const getCommentCodes = async () => {
    const response = await api.get('/deliveries/comment-codes');
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};

export const addCommentToDelivery = async (deliveryId: string, comment: string, comment_code_id: string) => {
    const response = await api.post(`/deliveries/${deliveryId}/add-comment`, { comment, comment_code_id });
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};


export const getDriverDeliveryGroups = async () => {
    const response = await api.get('/deliveries/driver/groups');
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
};

